import { useSettings } from "../context/SettingsContext";
import { SectionTitle } from "../components/shared";
import { Seo } from "../lib/seo";

export default function Privacy() {
  const { settings } = useSettings();
  return (
    <div className="mx-auto max-w-3xl px-6 py-16">
      <Seo title="Privacy Policy | Herbalife Rossano" description="Informativa sulla privacy del negozio online Herbalife Rossano: trattamento dei dati personali e di spedizione raccolti durante l'ordine." canonical="/privacy" />
      <SectionTitle eyebrow="Legale" title="Privacy Policy" />
      <div className="mt-8 text-slate-600 leading-relaxed whitespace-pre-line">{settings?.privacy_text}</div>
    </div>
  );
}
